module.exports = __webpack_public_path__ + "static/media/bb8-edit-24px.a7966812.svg";